var _path, _path2, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 196,
    viewBox: "0 0 114 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 138.924C114 170.408 88.4425 196 57 196C25.5576 196 -1.11865e-06 170.408 -2.49489e-06 138.924C-3.87112e-06 107.439 25.5576 81.8473 57 81.8473C88.2744 81.6789 114 107.439 114 138.924ZM32.4514 138.924C32.4514 152.393 43.3806 163.337 56.8319 163.337C70.2832 163.337 81.2124 152.393 81.2124 138.924C81.2124 125.454 70.2832 114.51 56.8319 114.51C43.3806 114.342 32.4514 125.454 32.4514 138.924Z",
    fill: "#FFCC00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 57.077C114 88.5616 88.4425 114.153 57 114.153C25.5576 114.153 -1.11865e-06 88.5616 -2.49489e-06 57.077C-3.87112e-06 25.5924 25.5576 0.000578717 57 0.000577342C88.2744 -0.167797 114 25.5924 114 57.077ZM32.4514 57.077C32.4514 70.5464 43.3806 81.4902 56.8319 81.4902C70.2832 81.4902 81.2124 70.5463 81.2124 57.077C81.2124 43.6076 70.2832 32.6638 56.8319 32.6638C43.3806 32.4954 32.4514 43.6076 32.4514 57.077Z",
    fill: "#3098F3"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 81,
    width: 114,
    height: 115
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114 138.924C114 170.408 88.4425 196 57 196C25.5576 196 -1.11865e-06 170.408 -2.49489e-06 138.924C-3.87112e-06 107.439 25.5576 81.8473 57 81.8473C88.2744 81.6789 114 107.439 114 138.924ZM32.4514 138.924C32.4514 152.393 43.3806 163.337 56.8319 163.337C70.2832 163.337 81.2124 152.393 81.2124 138.924C81.2124 125.454 70.2832 114.51 56.8319 114.51C43.3806 114.342 32.4514 125.454 32.4514 138.924Z",
    fill: "#FFCC00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114 57.077C114 88.5616 88.4425 114.153 57 114.153C25.5576 114.153 -1.11865e-06 88.5616 -2.49489e-06 57.077C-3.87112e-06 25.5924 25.5576 0.000578717 57 0.000577342C88.2744 -0.167797 114 25.5924 114 57.077ZM32.4514 57.077C32.4514 70.5464 43.3806 81.4902 56.8319 81.4902C70.2832 81.4902 81.2124 70.5463 81.2124 57.077C81.2124 43.6076 70.2832 32.6638 56.8319 32.6638C43.3806 32.4954 32.4514 43.6076 32.4514 57.077Z",
    fill: "#082C4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandVision);
export default __webpack_public_path__ + "static/media/brand-vision.357ef4f4c233283b48b375542ccc4254.svg";
export { ForwardRef as ReactComponent };